import { elements } from '@ecosystem/newron-design-system';
import React, { useCallback } from 'react';
import { useAnalytics } from '../../analytics';
import { pageElementClicked } from '../../analytics/trackingEvents';
import { FilterActionProps } from './types';

const { Icon } = elements;

const styles: { [key: string]: React.CSSProperties } = {
  FilterAction: {
    marginLeft: 0,
  },
};

export const FilterAction = ({
  children,
  className = 'px-1',
  disabled,
  label,
  testId,
  getTrackingTags,
  onClick,
}: FilterActionProps) => {
  const { track } = useAnalytics();

  const trackedClick = useCallback(() => {
    const { access, elementName, elementCategory, ...rest } = (getTrackingTags && getTrackingTags()) ?? {};
    const { event, tags } = pageElementClicked(elementName, rest, access, elementCategory);
    track(event, tags);
    onClick();
  }, [onClick, track, getTrackingTags]);

  let css =
    'button flex-nowrap font-bold gap-x-1 h-7 inline-flex items-center justify-between py-1 rounded text-xs transition-colors ' +
    className;
  if (disabled) {
    css += ' cursor-default text-inactive';
  } else {
    css += ' hover:bg-brand-light hover:text-brand-dark text-brand';
  }

  return (
    <button
      className={css}
      onClick={trackedClick}
      data-test-id={testId}
      disabled={disabled}
      style={styles.FilterAction}
      type="button"
    >
      <Icon color={disabled ? 'inactive' : 'brand'} size="xs">
        {children}
      </Icon>
      {label}
    </button>
  );
};
